import { put, takeLatest } from 'redux-saga/effects'
import { toast } from 'react-toastify';
import {
    GET_INVOICE_SETTINGS,
    GET_INVOICE_SETTINGS_SUCCESS,
    GET_INVOICE_SETTINGS_FAILURE,
    UPDATE_INVOICE_SETTINGS,
    UPDATE_INVOICE_SETTINGS_SUCCESS,
    UPDATE_INVOICE_SETTINGS_FAILURE
} from '../../../actions/index.types';
import { getInvoiceSettingsReq, updateInvoiceSettingsReq } from '../../../../axios/request/SocietyPortal/InvoiceSettingReqs/InvoiceSettingReqs';

function* getInvoiceSettingsSaga(action) {
    try {
        const response = yield getInvoiceSettingsReq(action);
        if (response.success === true) {
            yield put({ type: GET_INVOICE_SETTINGS_SUCCESS, data: response.data });
        } else {
            yield put({ type: GET_INVOICE_SETTINGS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch invoice settings");
        }
    } catch (error) {
        yield put({ type: GET_INVOICE_SETTINGS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

function* updateInvoiceSettingsSaga(action) {
    try {
        const response = yield updateInvoiceSettingsReq(action);
        if (response.success === true) {
            yield put({ type: UPDATE_INVOICE_SETTINGS_SUCCESS, data: response.data });
            toast.success(response.data.message || "Invoice settings updated successfully");
            if (action?.data?.onSuccess) { // Check if onSuccess callback is provided
              action.data.onSuccess();
            }

        } else {
            yield put({ type: UPDATE_INVOICE_SETTINGS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to update invoice settings");
        }
    } catch (error) {
        yield put({ type: UPDATE_INVOICE_SETTINGS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

export default function* InvoiceSettingSaga() {
    yield takeLatest(GET_INVOICE_SETTINGS, getInvoiceSettingsSaga);
    yield takeLatest(UPDATE_INVOICE_SETTINGS, updateInvoiceSettingsSaga);
}
